<template>
	<div>
		<c-dialog ref="dialog" title="选择日期" mask-close @resolve="resolveHandle">
			<ul class="list">
				<li v-for="(item, i) in typeList" :key="i" class="flex-center-cross" :class="{'z-crt': currentType == item}" @click="currentType = item">{{item.name}}</li>
			</ul>
			<div v-if="typeList.find(item => item.time_type == -99)" class="custom-box">
				<div v-show="currentType.time_type == -99" class="flex-center custom">
					<i class="icon tf">&#xe9ab;</i>
					<dl class="item flex-grow" @click="selectDate('start')">
						<dt>开始时间</dt>
						<dd><p :class="{'empty': !start}">{{start || '请选择'}}</p></dd>
					</dl>
					<hr>
					<dl class="item flex-grow" @click="selectDate('end')">
						<dt>结束时间</dt>
						<dd><p :class="{'empty': !end}">{{end || '请选择'}}</p></dd>
					</dl>
				</div>
			</div>
		</c-dialog>

		<c-datetime-picker
			ref="picker"
			type="date"
			:start="pickerType == 'end' ? start : ''"
			:end="pickerType == 'start' ? end : ''"
			format="yyyy-MM-dd"
			@input="setDate"
		></c-datetime-picker>
	</div>
</template>

<script>
	export default {
		name: 'timePicker',

		props: {
			type: [String, Number]
		},
		
		data() {
			return {
				typeList: [],
				currentType: null,
				pickerType: 'start',
				start: '',
				end: ''
			}
		},

		watch: {
			currentType() {
				this.start = this.end = '';
			}
		},
		
		methods: {
			init(init) {
				this.request({
					url: '/time/type',
					data: {
						type: this.type
					},
					success: data => {
						this.typeList = data;
						let index = init ? data.findIndex(item => item.time_type == init.time_type) : -1;
						this.currentType = data[index == -1 ? 0 : index];
						if (this.currentType.time_type == -99) {
							this.start = init.start_date || '';
							this.end = init.end_date || '';
						}
						this.resolveHandle();
					}
				});
			},

			open() {
				this.$refs.dialog.open();
				if (this._lastData) {
					this.currentType = this.typeList.find(item => item.time_type == this._lastData.time_type);
					this.start = this._lastData.start_date;
					this.end = this._lastData.end_date;
				}
			},

			selectDate(type) {
				this.pickerType = type;
				this.$refs.picker.open();
			},

			setDate(date) {
				this[this.pickerType] = date;
			},

			resolveHandle(stop) {
				if (this.currentType.time_type == -99 && (!this.start || !this.end)) {
					this.$message({
						message: '请选择时间范围'
					});
					stop();
					return;
				}
				this._lastData = {
					time_name: this.currentType.name,
					time_type: this.currentType.time_type,
					start_date: this.start,
					end_date: this.end
				};
				this.$emit('resolve', this._lastData);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.list {
		display: grid;
		grid-column-gap: .26rem;
		grid-row-gap: .24rem;
		grid-template-columns: repeat(2, 1fr);
		padding: .4rem .32rem;

		li {
			box-sizing: border-box;
			height: .8rem;
			border: 1px solid #F5F5F5;
			border-radius: .4rem;
			padding: 0 .38rem;
			font-size: .3rem;
			color: #444;
			background: #F5F5F5;

			&.z-crt {
				border-color: #2EBC78;
				color: #2EBC78;
				background: #F3FEF9;
			}
		}
	}

	.custom {
		height: 100%;
		padding: 0 .6rem 0 .32rem;

		&-box {
			height: 1.2rem;
			margin-bottom: .4rem;
		}

		.icon {
			margin-right: .28rem;
			font-size: .3rem;
			color: #666;
		}

		dl {
			font-size: .3rem;

			dt {
				margin-bottom: .16rem;
			}

			.empty {
				color: #bbb;
			}
		}

		hr {
			width: 1px;
			height: .8rem;
			border: none;
			margin-right: .3rem;
			background: #ddd;
		}
	}
</style>